import {
  cil3d,
  cilArrowThickBottom,
  cilArrowThickTop,
  cilArrowTop,
  cilCarAlt,
  cilEqualizer,
  cilLockLocked,
  cilMenu,
  cilPeople,
  cilSpeedometer,
  cilUser,
  cilCloudDownload,
  cilHome,
  cilBriefcase,
  cilBullhorn,
  cilBell,
  cilDelete,
  cilMoney,
  cilSettings,
  cilLibraryAdd,
  cilPhone,
  cilFile,
  cilFilter,
  cilCalendar,
  cilX,
  cilArrowRight,
  cilBarcode,
  cilTag,
  cilFolder,
  cilLocationPin,
  cilLowVision,
  cilZoom,
  cilBuilding,
  cilEnvelopeClosed,
  cilPencil,
  cilChevronTop,
  cilChevronBottom,
  cilHistory,
  cilReportSlash,
  cilNotes,
  cilPen,
  cilFullscreen,
  cilFullscreenExit,
  cilCheck,
  cilClock,
  cilCheckCircle,
  cilXCircle,
  cilWarning,
  cilMobile,
  cilBan,
} from '@coreui/icons';

export const iconSubset = {
  cilBan,
  cilArrowThickBottom,
  cilEqualizer,
  cilArrowThickTop,
  cil3d,
  cilPeople,
  cilMenu,
  cilSpeedometer,
  cilUser,
  cilLockLocked,
  cilArrowTop,
  cilCarAlt,
  cilCloudDownload,
  cilHome,
  cilBriefcase,
  cilBullhorn,
  cilBell,
  cilDelete,
  cilMoney,
  cilSettings,
  cilLibraryAdd,
  cilPhone,
  cilFile,
  cilFilter,
  cilCalendar,
  cilX,
  cilArrowRight,
  cilBarcode,
  cilTag,
  cilFolder,
  cilLocationPin,
  cilLowVision,
  cilZoom,
  cilBuilding,
  cilEnvelopeClosed,
  cilPencil,
  cilChevronTop,
  cilChevronBottom,
  cilHistory,
  cilReportSlash,
  cilNotes,
  cilPen,
  cilFullscreen,
  cilFullscreenExit,
  cilCheck,
  cilClock,
  cilCheckCircle,
  cilXCircle,
  cilWarning,
  cilMobile
  };